import styles from "./ProductReport.module.css";

import {
	Button,
	ComboBox,
	ComboBoxItem,
	FlexBox,
	Form,
	FormGroup,
	FormItem,
	Input,
	Label,
	Table,
	TableCell,
	TableColumn,
	TableRow,
} from "@ui5/webcomponents-react";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "../../app/constants";
import { useCookies } from "react-cookie";
import { CSVLink } from "react-csv";
import { Quotation } from "../../models/quotation.model";

export function ProductReport() {
	/**
	 * Product report global props
	 */
	const history = useHistory();
	const [products, setProducts] = useState<any[]>([]);
	const [cookie] = useCookies(["access"]);
	const [currentPage, setCurrentPage] = useState<number>(1);
	const [pageNavigator, setPageNavigator] = useState<number>(1);
	const [filterType, setFilterType] = useState<string>("");
	const [filterValue, setFilterValue] = useState<string>("");
	const apiAccess = {
		headers: { Authorization: `Bearer ${cookie["access"]}` },
	};
	const ITEMS_PER_PAGE: number = 50;
	const [quotations, setQuotations] = useState<Quotation[]>([]);

	/**
	 * Gets product report master data
	 */
	useEffect(() => {
		const apiAccess = {
			headers: { Authorization: `Bearer ${cookie["access"]}` },
		};
		axios.get(`${API_URL}/crud/product`, apiAccess).then((response: any) => {
			setProducts(response.data);
		});
		axios
			.post(`${API_URL}/query/product-report`, {}, apiAccess)
			.then((response: any) => {
				setProducts(response.data.rows);
			});
		axios.get(`${API_URL}/crud/quotation`, apiAccess).then((response: any) => {
			setQuotations(response.data);
		});
	}, [cookie]);

	/**
	 * Pagination
	 */
	const indexOfLastItem: number = currentPage * ITEMS_PER_PAGE;
	const indexOfFirtsItem: number = indexOfLastItem - ITEMS_PER_PAGE;
	const currentProducts: any[] = products.slice(
		indexOfFirtsItem,
		indexOfLastItem
	);
	const pageNumber: number = Math.ceil(products.length / ITEMS_PER_PAGE);
	const pageAvailable: number = pageNumber - pageNavigator;
	const pageNumbers = [];
	for (
		let i = pageNavigator;
		i <= pageNavigator + (pageAvailable < 5 ? pageAvailable : 5);
		i++
	) {
		pageNumbers.push(i);
	}

	/**
	 * Filter constants
	 */
	const FILTER_BY_QUICKOVERVIEW: string = "Descripción rápida";
	const FILTER_BY_DETAILEDDESCRIPTION: string = "Descripción detallada";
	const FILTER_BY_QUOTATION: string = "Número de proforma";

	/**
	 * Handles product filter
	 */
	const handleFilter = async () => {
		switch (filterType) {
			case FILTER_BY_QUICKOVERVIEW:
				try {
					const response = await axios.post(
						`${API_URL}/query/product-report-quickoverview`,
						{ filterValue: `%${filterValue}%` },
						apiAccess
					);
					setProducts(response.data.rows);
				} catch (error) {}
				break;
			case FILTER_BY_DETAILEDDESCRIPTION:
				try {
					const response = await axios.post(
						`${API_URL}/query/product-report-detaileddescription`,
						{ filterValue: `%${filterValue}%` },
						apiAccess
					);
					setProducts(response.data.rows);
				} catch (error) {}
				break;
			case FILTER_BY_QUOTATION:
				try {
					const response = await axios.post(
						`${API_URL}/query/product-report-quotation`,
						{ filterValue: filterValue },
						apiAccess
					);
					setProducts(response.data.rows);
				} catch (error) {}
				break;
		}
	};

	return (
		<div className={styles.productReport}>
			<Button
				icon="sys-back-2"
				onClick={() => history.push("/reports")}
				design="Emphasized"
			>
				Atras
			</Button>
			<br />
			<Form>
				<FormGroup titleText="Filtrar	">
					<FormItem label={"Entrada"}>
						{filterType === FILTER_BY_QUOTATION && (
							<ComboBox
								style={{ width: "100%" }}
								onChange={(e) => setFilterValue(e.target.value.toString())}
								value={filterValue}
								disabled={filterType === ""}
							>
								{quotations.map((quotation: Quotation) => (
									<ComboBoxItem
										key={quotation.quotationid}
										text={quotation.quotationid.toString()}
									/>
								))}
							</ComboBox>
						)}
						{filterType !== FILTER_BY_QUOTATION && (
							<Input
								type="Text"
								style={{ width: "100%" }}
								onInput={(e) => setFilterValue(e.target.value.toString())}
								disabled={filterType === ""}
							/>
						)}
					</FormItem>
					<FormItem label={"Tipo de filtro"}>
						<ComboBox
							style={{ width: "100%" }}
							onChange={(e) => {
								setFilterType(e.target.value.toString());
								setFilterValue("");
							}}
							value={filterType}
						>
							<ComboBoxItem text={FILTER_BY_QUICKOVERVIEW} />
							<ComboBoxItem text={FILTER_BY_DETAILEDDESCRIPTION} />
							<ComboBoxItem text={FILTER_BY_QUOTATION} />
						</ComboBox>
					</FormItem>
					<FormItem label={""}>
						<Button
							design="Positive"
							style={{ width: "100%" }}
							icon="search"
							onClick={handleFilter}
						>
							Buscar
						</Button>
					</FormItem>
					<FormItem label={""}>
						<CSVLink
							data={products}
							filename={`product-report-${new Date().toLocaleString("es-GT", {
								timeZone: "America/Guatemala",
							})}`}
							style={{ width: "100%" }}
						>
							<Button icon="excel-attachment" style={{ width: "100%" }}>
								Descargar CSV
							</Button>
						</CSVLink>
					</FormItem>
				</FormGroup>
			</Form>
			<br />
			<FlexBox justifyContent="End">
				{pageNavigator > 1 && (
					<Button
						icon="close-command-field"
						onClick={() => setPageNavigator((prev: any) => prev - 1)}
					/>
				)}
				{pageNumbers.map((number: any) => (
					<Button
						key={number}
						onClick={() => setCurrentPage(number)}
						design={currentPage === number ? "Emphasized" : "Default"}
					>
						{number}
					</Button>
				))}
				{pageAvailable > 5 && (
					<Button
						icon="open-command-field"
						onClick={() => setPageNavigator((prev: any) => prev + 1)}
					/>
				)}
			</FlexBox>
			<br />
			<Table
				columns={
					<>
						<TableColumn>
							<Label>Factura</Label>
						</TableColumn>
						<TableColumn demandPopin minWidth={1000} popinText="Proforma">
							<Label>Proforma</Label>
						</TableColumn>
						<TableColumn
							demandPopin
							minWidth={2000}
							popinText="Descripción Rápida"
						>
							<Label>Descripción Rápida</Label>
						</TableColumn>
						<TableColumn
							demandPopin
							minWidth={2000}
							popinText="Descripción Detallada"
						>
							<Label>Descripción Detallada</Label>
						</TableColumn>
						<TableColumn
							demandPopin
							minWidth={1000}
							popinText="Código de Facturación"
						>
							<Label>Código de Facturación</Label>
						</TableColumn>
						<TableColumn demandPopin minWidth={1000} popinText="Precio">
							<Label>Precio</Label>
						</TableColumn>
						<TableColumn demandPopin minWidth={1000} popinText="Cantidad">
							<Label>Cantidad</Label>
						</TableColumn>
						<TableColumn demandPopin minWidth={1000} popinText="Total">
							<Label>Total</Label>
						</TableColumn>
					</>
				}
			>
				{currentProducts.map((product, i) => (
					<TableRow key={i}>
						<TableCell>
							<Label>{product.documentnumber}</Label>
						</TableCell>
						<TableCell>
							<Label>{product.quotationid}</Label>
						</TableCell>
						<TableCell>
							<Label>{product.quickoverview}</Label>
						</TableCell>
						<TableCell>
							<Label>{product.detaileddescription}</Label>
						</TableCell>
						<TableCell>
							<Label>{product.billingcode}</Label>
						</TableCell>
						<TableCell>
							<Label>{product.unitprice}</Label>
						</TableCell>
						<TableCell>
							<Label>{product.quantity}</Label>
						</TableCell>
						<TableCell>
							<Label>{product.subtotal}</Label>
						</TableCell>
					</TableRow>
				))}
			</Table>
		</div>
	);
}
